<div mat-dialog-title>
    Select location
    <span class="float-right pointer">
        <i class="fa fa-times " (click)="close()"></i>
    </span>
</div>
<mat-dialog-content class="fullscreen-dialog" style="margin-top: -1rem; overflow:hidden;">
    <ng-container *ngIf="multiple">
        <div class="row">
            <div class="col-md-4" style="border-right: 1px solid gainsboro;">
                <ul>
                    <li class="title-of-city"> City list </li>
                    <li (click)="setCurrentCity(item) "
                        [ngClass]="{'active': current_option &&current_option.id == item.id}" class="link"
                        *ngFor="let item of selected_options">
                        {{item.title}}
                    </li>
                </ul>
            </div>
            <div class="col-md-8">
                <div class="row">
                    <div class="col-lg-12 form-group">
                        <mat-form-field class="search_text">
                            <!-- <app-google-search-autocomplete style="padding: 0;" class="searchTerm" (setAddress)="getAddress($event);" [adressType]="geocode" [(ngModel)]="google_search">
                            </app-google-search-autocomplete> -->
                            <input [(ngModel)]="google_search" type="search" (input)="setTimer()" matInput
                                placeholder="Search" style="width: 100%;" #addresstext />
                            <!-- <mat-icon matSuffix (click)="getPlaceByAddress()" class="pointer">search</mat-icon> -->
                            <mat-icon matSuffix (click)="getCurrentLocation()" class="pointer"
                                title="Your current location">
                                my_location
                            </mat-icon>

                        </mat-form-field>
                        <div>
                            <mat-progress-bar *ngIf="!show_map" style="width:100%; margin-top: -20px; font-size: large;"
                                mode="indeterminate" aria-valuenow="100">Loading...</mat-progress-bar>
                        </div>

                    </div>
                </div>
                <google-map gle-map class="map-canvas" width="100%" height="407px" [zoom]="zoom" [center]="center"
                    [options]="options" (mapClick)="click($event)">

                    <map-marker #markerElem *ngFor="let marker of markers" [position]="marker.position"
                        [label]="marker.label" [title]="marker.title" [options]="marker.options">
                    </map-marker>

                    <map-info-window>{{ infoContent }}</map-info-window>
                </google-map>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!multiple">
        <form [formGroup]="form_group" *ngIf="enable_description">

            <div class="row">
                <div class="col-lg-12 mt-2">
                    <mat-form-field class="search_text">
                        <!-- <app-google-search-autocomplete style="padding: 0;" class="searchTerm" (setAddress)="getAddress($event);" [adressType]="geocode" [(ngModel)]="google_search">
                    </app-google-search-autocomplete> -->
                        <input [(ngModel)]="google_search" type="search" (input)="setTimer()" matInput
                            placeholder="Search" style="width: 100%;" #addresstext />
                        <!-- <mat-icon matSuffix (click)="getPlaceByAddress()" class="pointer">search</mat-icon> -->
                        <mat-icon matSuffix (click)="getCurrentLocation()" class="pointer"
                            title="Your current location">
                            my_location
                        </mat-icon>

                    </mat-form-field>
                    <div *ngIf="!show_map">
                        <mat-progress-bar style="width:100%; margin-top: -20px; font-size: large;" mode="indeterminate"
                            aria-valuenow="100">Loading...</mat-progress-bar>
                    </div>

                </div>
                <div class="col-md-12">
                    <mat-form-field floatLabel="always">
                        <mat-label> {{label}} </mat-label>
                        <input matInput [formControlName]="'locationDesc'" [placeholder]="placeholder">
                    </mat-form-field>

                </div>
            </div>
        </form>

        <google-map gle-map class="map-canvas" width="100%" height="407px" [zoom]="zoom" [center]="center"
            [options]="options" (mapClick)="click($event)">

            <map-marker #markerElem *ngFor="let marker of markers" [position]="marker.position" [label]="marker.label"
                [title]="marker.title" [options]="marker.options">
            </map-marker>

            <map-info-window>{{ infoContent }}</map-info-window>
        </google-map>


    </ng-container>


    <div id="legend"></div>
</mat-dialog-content>
<div mat-dialog-actions>
    <span style="font-size: var(--font-13) !important;" id="tm-popup-notification-window"> </span>

    <button style="min-width: 5rem;" class="ml-auto btn-sm  blob-btn-cancel btn mx-1 mx-1 tallite-action"
        (click)="close1()">
        {{ 'BTN.cancel' | translate}}
        <span class="blob-btn-cancel__inner">
            <span class="blob-btn-cancel__blobs">
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
            </span>
        </span>
    </button>
    <button style="min-width: 5rem;" (click)="close()"
        class="blob-btn float-right btn   mx-1 float-right btn-sm tallite-action" type="submit">
        {{ 'BTN.ok' | translate }}
        <span class="blob-btn__inner">
            <span class="blob-btn__blobs">
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
            </span>
        </span>
    </button>
</div>